var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapGridArea"},[_vm._m(0),_c('span',[_vm._v("정렬 상태설정 : ")]),_vm._m(1),_c('SBGrid',{ref:"grid",staticStyle:{"width":"100%","height":"550px"},attrs:{"id":"grid","data":_vm.gridJson,"columns":_vm.grid1columns,"gridattr":{
      backcoloralternate: '#efefef',
      rowheight: '26',
      rowheader: 'seq',
      selectmode:'free',
      mergecells:'bycol',
      saveorgdata: true
    }}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_vm._v("합계/소계 그리드 "),_c('span',{staticStyle:{"font-size":"12px","color":"#aaa","font-style":"italic"}},[_vm._v("정렬 상태를 수정하여 결과를 확인할 수 있습니다.")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('select',{attrs:{"id":"totalStatus","onChange":"totalStatusChanged(value)"}},[_c('option',{attrs:{"value":"none"}},[_vm._v("기본")]),_c('option',{attrs:{"value":"top"}},[_vm._v("상단")]),_c('option',{attrs:{"value":"bottom"}},[_vm._v("하단")])])
}]

export { render, staticRenderFns }